module.exports = __webpack_public_path__ + "img/image_5.12f477d5.jpg";